import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import {
	PlaylistFetch,
	push_questioninto_mainquestion,
} from "../../redux/reducers/PlaylistSlice";
import CustomToast from "../../utlis/toast/CustomToast";
import { ApiConnector } from "../../axios/apiClient";
import { LIKE } from "../../axios/AllBaseUrl";
import { QuestionArray } from "../../redux/reducers/SearchQuestionSlice";
import ColapsableCard from "../ColapsableCard";
import { Empty, Pagination, Row } from "antd";
import Loader from "../../utlis/Loader/Loader";
/**
 * SuggestedQuestion Component
 * ---------------------------
 * Displays a paginated list of suggested questions
 * based on active search results.
 *
 * Responsibilities:
 * 1. Render searched/suggested questions
 * 2. Handle question like/unlike actions
 * 3. Add questions to playlist (create/edit modes)
 * 4. Handle pagination
 * 5. Show loading and empty states
 */
const SuggestedQuestion = (prop: any) => {
	const { onChange, setModal2Open, handlePageChange, pageData } = prop;

	const dispatch = useDispatch();
	/**
	 * Search state containing question results
	 */
	const search = useSelector((state: RootState) => state.search);

	/**
	 * Playlist state (create/edit mode & questions)
	 */
	const playlist = useSelector((state: RootState) => state.playlist);

	/**
	 * Handles like/unlike toggle for a question
	 * Updates backend and syncs Redux state
	 */
	let toggleIcon = async (id, liked, totalLike) => {
		let res: any = await ApiConnector("post", `${LIKE}`, {
			question_id: id,
		});
		if (res.data.ok) {
			dispatch(
				QuestionArray({ id: id, liked: liked, totalLike: totalLike }),
			);
		}
	};

	//   saga
	// useEffect(() => {
	// dispatch(SuggestionFetch(suggestions));
	// }, [dispatch]);

	//    thunk

	// useEffect(() => {
	// 	dispatch(PlaylistFetch());
	// }, []);
	/**
	 * Adds a question to the playlist
	 * Handles both create and edit modes
	 * Prevents duplicate question additions
	 */
	const Questionadded = (id, title) => {
		// Restrict adding only from create playlist page
		if (window.location.href.endsWith("/createPlaylist")) {
			/**
			 * CREATE MODE: Empty playlist
			 */
			if (playlist.mode === 0 && playlist.question_ids?.length === 0) {
				dispatch(push_questioninto_mainquestion({ id, title }));
			}
			/**
			 * EDIT MODE: Empty playlist
			 */
			if (
				playlist.mode === 1 &&
				playlist.playlist_to_edit.question_ids?.length === 0
			) {
				dispatch(push_questioninto_mainquestion({ id, title }));
			}
			/**
			 * CREATE MODE: Prevent duplicate question addition
			 */
			if (playlist.mode === 0 && playlist.question_ids.length !== 0) {
				let res = playlist?.question_ids?.map((value: any, index) => {
					if (value?.q_id === id) {
						return -1;
					}
					// if (value?.question_traslation[0]?.title === title) {
					// 	return -1;
					// }
				});

				if (res.includes(-1)) {
					CustomToast("error", "Already added in your playlist");
				}
				if (!res.includes(-1)) {
					dispatch(push_questioninto_mainquestion({ id, title }));
				}
			}
			/**
			 * EDIT MODE: Prevent duplicate question addition
			 */
			if (
				playlist.mode === 1 &&
				playlist.playlist_to_edit.question_ids.length !== 0
			) {
				let res = playlist?.playlist_to_edit?.question_ids?.map(
					(value: any, index) => {
						if (value?.q_id === id) {
							return -1;
						}
					},
				);

				if (res.includes(-1)) {
					CustomToast("error", "Already added in your playlist");
				}
				if (!res.includes(-1)) {
					dispatch(push_questioninto_mainquestion({ id, title }));
				}
			}
		}
	};

	return (
		<>
			{search?.loading && <Loader />}
			{search?.apiCall && search?.search?.length === 0 && <Empty />}
			{search?.search?.length !== 0 && (
				<Row style={{ marginBottom: "6px" }}>
					<Pagination
						current={search?.currentPage}
						total={search?.totalItems}
						showSizeChanger
						pageSize={pageData?.pageSize ? pageData?.pageSize : 10}
						pageSizeOptions={[10, 20, 50, 100]}
						// showTotal={(total, range) =>
						// 	`Showing ${range[0]}-${range[1]} of ${total} questions`
						// }
						// items in ${search?.totalPages} pages
						onChange={(page, pageSize) =>
							handlePageChange(page, pageSize)
						}
					/>
				</Row>
			)}
			<div>
				{search?.search?.length > 0 &&
					search?.search?.map((value, index) => {
						return (
							<React.Fragment key={index}>
								<ColapsableCard
									onChange={onChange}
									index={index}
									value={value}
									image={value?.image}
									Option={value?.option}
									Questionadded={Questionadded}
									toggleIcon={toggleIcon}
									question_setting={undefined}
								/>
							</React.Fragment>
						);
					})}
			</div>
		</>
	);
};

export default SuggestedQuestion;
